import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../../shared/components/PageHeader';
import { EmptyState } from '../../../shared/components/EmptyState';
import { useDocumentTitle } from '../../../shared/hooks/useDocumentTitle';

export function UnauthorizedPage(): React.ReactElement {
  useDocumentTitle('Unauthorized · Triplicity Backoffice');

  return (
    <div>
      <PageHeader title="Access denied" subtitle="You need admin access to view this area." />
      <EmptyState
        title="You are not authorized"
        description="Contact your administrator if you believe this access should be available to your account."
        action={<Link to="/">Back to home</Link>}
      />
    </div>
  );
}
